import React, { type CSSProperties, type ReactNode } from "react";
import View from "../../View";
import useStyles from "./MelaModalFooter.styles";

export interface MelaModalFooterProps {
  children: ReactNode;
  containerClassName?: string;
  containerStyle?: CSSProperties;
  dataTestId?: string;
}

export const MelaModalFooter = ({
  children,
  containerClassName = "",
  containerStyle,
  dataTestId = "",
}: MelaModalFooterProps) => {
  const styles = useStyles();

  return (
    <View
      className={`${styles.buttonGroup} ${containerClassName}`}
      style={containerStyle}
      dataTestId={dataTestId}
    >
      {children}
    </View>
  );
};
